export default {
  General: {
    Email: "Адрес эл. почты",
    Send: "Отправить",
    Done: "Готово",
    Finish: "Завершить",
    Try_again: "Повторить попытку",
    or: "или"
  },
  SamsungType: {
    bixby: "С Bixby",
    no_bixby: "Без Bixby",
    home_button: "С кнопкой «Домой»"
  },
  sendEmail: {
    repair_tip1: "Эта модель не может быть отремонтирована с помощью мобильного приложения. Мы отправим вам решение для настольного компьютера по электронной почте.",
    check_tip1: "Проверку устройства нельзя завершить только с помощью мобильного приложения. Мы отправим вам решение для компьютера по электронной почте.",
    tip1: "Эту модель невозможно разблокировать с помощью мобильного приложения. Мы вышлем вам решение для компьютеров по электронной почте.",
    tip2: "Подключите телефон к компьютеру с помощью кабеля для передачи данных, чтобы повысить вероятность успеха.",
    enter_address: "Введите адрес электронной почты.",
    enter_correct_address: "Пожалуйста, введите правильный адрес электронной почты.",
    confidential: "Ваш адрес электронной почты будет храниться в строгой конфиденциальности.",
    open_link: "Откройте {0} в любом браузере на компьютере, чтобы скачать Dr.Fone.",
    has_sent: "Адрес эл. почты отправлен",
    almost: "Почти готово",
    step1: "Шаг 1",
    open_email: "Откройте эл. письмо на компьютере и скачайте версию Dr.Fone для компьютеров, используя ссылку из письма.",
    step2: "Шаг 2",
    repair_launch_tip: "Запустите Dr.Fone System Repair и войдите в свой аккаунт, чтобы использовать функцию ремонта.",
    check_launch_tip: "Установите настольную версию Dr.Fone и войдите в систему под той же учетной записью. Нажмите «My Device» и следуйте инструкциям на экране, чтобы подключить устройство. После подключения нажмите «Device Detail», чтобы просмотреть подробные результаты проверки.",
    launch_tip: "Запустите Dr.Fone Unlock и войдите в учетную запись, чтобы использовать функцию разблокировки.",
    contact_us: "Нужна помощь? Обратитесь к нам."
  },
  Unlock: {
    recoveryMode: "Переведите устройство в режим восстановления",
    wipe_cache: "Очистите раздел кэша на устройстве",
    wipe_data: "Следуйте инструкциям, чтобы стереть данные с устройства",
    completed: "Разблокировка завершена",
    completed_tip: "Проверьте, снята ли блокировка экрана на вашем устройстве. Если нет, повторите попытку.",
    contact_us: "Не удалось разблокировать? Обратитесь к нам за помощью."
  },
  UnlockStep: {
    sa1: "1. Отключите питание телефона и подключите его к компьютеру ",
    sa2: "2. Нажмите и удерживайте кнопку увеличения громкости + Bixby + кнопку питания одновременно",
    sa3: "3. После появления логотипа Samsung отпустите кнопки и подождите несколько секунд",
    sa4: "4. Теперь устройство должно перейти в режим восстановления. Выберите «Перезагрузить через загрузчик», чтобы перейти в режим скачивания.",
    sb1: "1. Отключите питание телефона и подключите его к компьютеру",
    sb2: "2. Нажмите и удерживайте кнопки питания и увеличения громкости одновременно",
    sb3: "3. Продолжайте удерживать эти две кнопки, даже когда устройство запустит рез. копирование",
    sb4: "4. Теперь устройство должно перейти в режим восстановления. Выберите «Перезагрузить через загрузчик», чтобы перейти в режим скачивания.",
    sc1: "1. Отключите питание телефона и подключите его к компьютеру",
    sc2: "2. Нажмите и удерживайте кнопку увеличения громкости + «Домой» + кнопку питания одновременно",
    sc3: "3. После появления логотипа Samsung отпустите кнопки и подождите несколько секунд",
    sc4: "4. Теперь устройство должно перейти в режим восстановления. Выберите «Перезагрузить через загрузчик», чтобы перейти в режим скачивания.",
    s5: "5. Нажмите кнопку громкости, чтобы выбрать «Стирание данных/сброс настроек», а затем нажмите кнопку питания для подтверждения",
    s6: "6. Нажмите кнопку громкости, чтобы выбрать «Да», а затем нажмите кнопку питания для подтверждения",
    s7: "7. Нажмите «Очистить раздел кэша» и выберите «Да»",
    s8: "8. Выберите «Перезагрузить систему» и нажмите кнопку питания для подтверждения. Перезагрузка устройства займет некоторое время.",
    common1: "Выключите телефон.",
    common2: "Нажмите кнопку увеличения громкости и кнопку питания и удерживайте их несколько секунд.",
    common3: "Когда на экране появится режим восстановления, отпустите все кнопки.",
    m4: "Выберите «Стереть данные», используя клавиши громкости. Затем подтвердите с помощью кнопки питания.",
    m5: "Выберите «Стереть все данные».",
    m6: "Выберите «Подтвердить» и дождитесь завершения процесса.",
    m7: "Вернитесь в главное меню с помощью клавиши питания.",
    m8: "Выберите «Перезагрузить».",
    m9: "Выберите «Перезагрузить систему».",
    h4: "Выберите «Стереть данные», используя клавиши громкости. Затем подтвердите с помощью кнопки питания.",
    h5: "Выберите «Сброс до заводских настроек».",
    h6: "Введите слово «Да» и выберите «Сброс до заводских настроек».",
    h7: "Все файлы будут удалены.",
    h8: "Выберите «Назад», чтобы вернуться в главное меню.",
    h9: "Выберите «Перезапустить»."
  }
};
